import { Injectable } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { TaskManagerState } from './taskManagerState';
import { TaskManagerProxyService } from 'app/modules/remote-control-ng/services/taskManagerProxyService';

export interface ITaskManagerService {
  getState: (deviceId: string) => TaskManagerState;
  resetState: (deviceId: string) => void;
  transfer: (taskManagerService: ITaskManagerService, deviceId: string) => void;
}

class DeviceIdToTaskManagerStateMap {
  [deviceId: string]: TaskManagerState;
}

@Injectable({
  providedIn: 'root',
})
export class TaskManagerService implements ITaskManagerService {
  private states: DeviceIdToTaskManagerStateMap = new DeviceIdToTaskManagerStateMap();

  constructor(private saI18nPipe: XsI18nPipe, private taskManager: TaskManagerProxyService) {}

  public transfer = (taskManagerService: ITaskManagerService, deviceId: string) => {
    const oldState = taskManagerService.getState(deviceId);
    const newState = this.getState(deviceId);
    if (oldState) {
      newState.transfer(oldState);
    }
  };

  public getState = (deviceId: string): TaskManagerState => {
    const keys = Object.keys(this.states);
    for (const key of keys) {
      if (key === deviceId || key.endsWith(deviceId) || deviceId.endsWith(key)) {
        return this.states[key];
      }
    }

    const state = new TaskManagerState(this.saI18nPipe, this.taskManager);
    this.states[deviceId] = state;
    return state;
  };

  public resetState = (deviceId: string) => {
    const state = this.states[deviceId];
    if (state) {
      delete this.states[deviceId];
    }
  };
}
